import React, { useState, useEffect } from 'react';
import axios from 'axios';
import QRCode from 'react-qr-code';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from 'reactstrap';

const FormPageVerification = () => {
  const ACCESS_CODE = 'rla165165';

  const generateSerialNumber = () => {
    const now = new Date();
    const datePart = `${String(now.getDate()).padStart(2, '0')}${String(
      now.getMonth() + 1
    ).padStart(2, '0')}-${now.getFullYear()}`;
    const randChars = Math.random().toString(36).substring(2, 4).toUpperCase();
    const randNums = Math.floor(1000000000 + Math.random() * 9000000000);
    return `${datePart}-${randChars}-${randNums}`;
  };

  const [formData, setFormData] = useState({
    serial_number: generateSerialNumber(),
    name: '',
    event: '',
  });

  const [submittedData, setSubmittedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [modalQR, setModalQR] = useState(false);
  const [countdown, setCountdown] = useState(5);

  const [modalCode, setModalCode] = useState(false);
  const [accessCode, setAccessCode] = useState('');

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setAccessCode('');
    setModalCode(true); // Tampilkan modal input kode
  };

  const handleAccessCodeSubmit = async () => {
    if (accessCode !== ACCESS_CODE) {
      setModalCode(false);
      setError('Anda tidak memiliki hak akses.');
      return;
    }

    setModalCode(false);
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(
        'https://app.rlagency.id/api_everification/register-ev.php',
        formData
      );

      if (response.data?.success || response.status === 200) {
        setSubmittedData(formData);
        setModalQR(true);
        setCountdown(5);
        setFormData({
          serial_number: generateSerialNumber(),
          name: '',
          event: '',
        });
      } else {
        setError('Gagal menyimpan data.');
      }
    } catch (err) {
      setError('Terjadi kesalahan saat koneksi ke server.');
    }

    setLoading(false);
  };

  useEffect(() => {
    let timer;
    if (modalQR && countdown > 0) {
      timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    } else if (modalQR && countdown === 0) {
      setModalQR(false);
    }
    return () => clearTimeout(timer);
  }, [modalQR, countdown]);

  const verificationUrl = submittedData
    ? `https://app.rlagency.id/verify/${submittedData.serial_number}`
    : '';

  return (
    <div className="container mt-5" style={{ maxWidth: '600px' }}>
      <h2 className="mb-4">Generate E-Verification</h2>

      {error && <div className="alert alert-danger">{error}</div>}

      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="serial_number">Serial Number</Label>
          <Input
            type="text"
            name="serial_number"
            id="serial_number"
            value={formData.serial_number}
            readOnly
            className="bg-light"
          />
        </FormGroup>

        <FormGroup>
          <Label for="name">Dokumen terkait ditujukan kepada (Nama Lengkap/ instansi)</Label>
          <Input
            type="text"
            name="name"
            id="name"
            required
            value={formData.name}
            onChange={handleChange}
          />
        </FormGroup>

        <FormGroup>
          <Label for="event">Dokumen terkait berisi tentang (Keterangan Dokumen)</Label>
          <Input
            type="text"
            name="event"
            id="event"
            required
            value={formData.event}
            onChange={handleChange}
          />
        </FormGroup>

        <Button color="primary" disabled={loading}>
          {loading ? 'Menyimpan...' : 'Generate QR Code'}
        </Button>
      </Form>

      {/* Modal Input Kode Akses */}
      <Modal isOpen={modalCode} centered>
        <ModalHeader>Verifikasi Akses</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="access_code">Masukkan Kode Akses</Label>
            <Input
              type="password"
              id="access_code"
              value={accessCode}
              onChange={(e) => setAccessCode(e.target.value)}
              placeholder="Kode akses rahasia"
              autoFocus
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalCode(false)}>
            Batal
          </Button>
          <Button color="primary" onClick={handleAccessCodeSubmit}>
            Verifikasi
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal QR Code */}
      <Modal isOpen={modalQR} centered>
        <ModalHeader toggle={() => setModalQR(false)}>Generate Verifikator</ModalHeader>
        <ModalBody className="text-center">
          {submittedData && (
            <>
              <QRCode value={verificationUrl} size={200} />
              <p className="mt-3"><strong>Nama:</strong> {submittedData.name}</p>
              <p><strong>Event:</strong> {submittedData.event}</p>
              <p><strong>Serial:</strong> {submittedData.serial_number}</p>
              <p><strong>URL:</strong><br /><a href={verificationUrl} target="_blank" rel="noreferrer">{verificationUrl}</a></p>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <small className="text-muted">Menutup dalam {countdown} detik...</small>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default FormPageVerification;
